module.exports = __webpack_public_path__ + "img/yano_Q_400_15_7.0d105fb3.png";